import { LocalityModel } from "@/types/LocalityModel";
import Pagination from "./Pagination";
import { LocaliteCard } from "./LocaliteCard";

export function ListWithPages({
  localites,
  currentPage,
  handleClick,
  numberOfPages,
}: {
  localites: LocalityModel[];
  currentPage: number;
  handleClick: (page: number) => void;
  numberOfPages: number;
}) {
  return (
    <>
      <div className="grid h-full grid-cols-1 gap-1 sm:grid-cols-3">
        {localites.map((localite) => (
          <LocaliteCard
            key={localite.province + localite.id}
            localite={localite}
          />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        handleClick={handleClick}
        pages={numberOfPages}
      />
    </>
  );
}
